import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  private readonly STORAGE_PREFIX = 'acv_filters_';
  private readonly SEARCH_PREFIX = 'acv_search_';

  // In-memory fallback (legacy support)
  private filters: { [tabNumber: number]: any } = {};
  private search: { [route: string]: string } = {};

  constructor() {}

  // ===== SessionStorage-based methods (for persistence across refresh/tab switch) =====

  /**
   * Get filter from sessionStorage by unique key
   */
  public getFilterByKey(key: string): any {
    const stored = sessionStorage.getItem(this.STORAGE_PREFIX + key);
    return stored ? stored : null;
  }

  /**
   * Set filter to sessionStorage by unique key
   */
  public setFilterByKey(key: string, filter: any): void {
    if (filter) {
      sessionStorage.setItem(this.STORAGE_PREFIX + key, filter);
    } else {
      sessionStorage.removeItem(this.STORAGE_PREFIX + key);
    }
  }

  /**
   * Clear filter from sessionStorage by unique key
   */
  public clearFilterByKey(key: string): void {
    sessionStorage.removeItem(this.STORAGE_PREFIX + key);
  }

  /**
   * Get search from sessionStorage by unique key
   */
  public getSearchByKey(key: string): string {
    return sessionStorage.getItem(this.SEARCH_PREFIX + key) || '';
  }

  /**
   * Set search to sessionStorage by unique key
   */
  public setSearchByKey(key: string, searchValue: string): void {
    if (searchValue) {
      sessionStorage.setItem(this.SEARCH_PREFIX + key, searchValue);
    } else {
      sessionStorage.removeItem(this.SEARCH_PREFIX + key);
    }
  }

  /**
   * Clear search from sessionStorage by unique key
   */
  public clearSearchByKey(key: string): void {
    sessionStorage.removeItem(this.SEARCH_PREFIX + key);
  }

  // ===== Legacy in-memory methods (kept for backward compatibility) =====

  public setSearch(route: string, search: string): void {
    this.search[route] = search;
  }
  public getSearch(route: string): string {
    return this.search[route] || '';
  }
  public getFilterByTabNumber(tabNumber: number): any {
    return this.filters[tabNumber] || null;
  }

  public setFilterByTabNumber(tabNumber: number, filter: any): void {
    this.filters[tabNumber] = filter;
  }

  public clearFilterByTabNumber(tabNumber: number): void {
    this.filters[tabNumber] = null;
  }

  public clearAllFilters(): void {
    this.filters = {};
    // Also clear sessionStorage filters
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && (key.startsWith(this.STORAGE_PREFIX) || key.startsWith(this.SEARCH_PREFIX))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
  }
}
